.vc-user-connection {
    all: unset;
    display: inline-block;
    cursor: pointer;
}

.vc-sc-tooltip {
    display: inline-flex;
    gap: 0.25em;
    align-items: center;
}

.vc-sc-connection-name {
    word-break: break-all;
}

.vc-sc-tooltip-icon {
    min-width: 16px;
}
